import React from "react"
import classNames from "classnames"

export const PriceTable = ({ children }: { children: React.ReactNode }) => (
  <div className="cobalt-PriceTable">{children}</div>
)

export interface PriceTableRowProps {
  label: string
  value: string
  discounted?: boolean
}

export const PriceTableRow = ({
  label,
  value,
  discounted = false,
}: PriceTableRowProps) => (
  <div className="cobalt-PriceTable__Row">
    <div className="cobalt-PriceTable__Label">{label}</div>
    <div
      className={classNames("cobalt-PriceTable__Value", {
        "cobalt-PriceTable__Value--discount": discounted,
      })}
    >
      {value}
    </div>
  </div>
)

PriceTable.Row = PriceTableRow

export default PriceTable
